import React from 'react';
import Layout from '../layouts/two';
import RankingsSection from '../rankings/index';
import TournamentLink from './partials/tournament';
import ScrollAnimation from 'react-animate-on-scroll';
import SubNav from './partials/sub_nav';
import ESPN from './partials/espn';
import _ from 'lodash';

class Rankings extends React.Component {
    state = {}

    // 
    componentWillMount() {

        const { tournaments, upcoming, past, params, tournamentsActions } = this.props, { id } = params;
        if ((tournaments && tournaments.length && _.find(tournaments, t => parseInt(t.id, 10) === parseInt(id, 10)))) {
            this.setState({ tournament: _.find(tournaments, t => parseInt(t.id, 10) === parseInt(id, 10)) });
        } else if ((upcoming && upcoming.length && _.find(upcoming, t => parseInt(t.id, 10) === parseInt(id, 10)))) {
            this.setState({ tournament: _.find(upcoming, t => parseInt(t.id, 10) === parseInt(id, 10)) });
        } else if ((past && past.length && _.find(past, t => parseInt(t.id, 10) === parseInt(id, 10)))) {
            this.setState({ tournament: _.find(past, t => parseInt(t.id, 10) === parseInt(id, 10)) });
        }
        tournamentsActions.fetch(id);
    }
    componentWillReceiveProps = nextProps => {
        const { tournament } = nextProps;
        this.setState({ tournament: this.state.tournament || tournament });
    }

    render() {
        const { params, ageGroups } = this.props, { id } = params, { tournament } = this.state, { Medal = {} } = (tournament || {});
        let bi = (tournament && tournament.IdMedal) ? `/images/medals/${tournament.IdMedal}.jpg` : "/images/backgrounds/edoardo-busti-413350-unsplash.jpg";
        return <Layout medal={Medal} nbs="tournaments" title="RANKINGS" bi={bi}>
            <section>
                <div id="tournament" style={{ marginTop: '-4.5em' }}>
                    <div className="w3-container w3-content">
                        <div className="d-flex flex-column">
                            <ul className="no-margin no-padding" style={{ listStyle: 'none' }}>
                                <ScrollAnimation animateIn="fadeIn" animateOnce={true} component="li"
                                    className="w3-card margin-top" style={{ backgroundColor: 'white', borderRadius: 4 }}>
                                    <TournamentLink hideLink={true} tournament={tournament} />
                                </ScrollAnimation>
                            </ul>
                        </div>
                    </div>
                    {tournament !== null && <div className="w3-container w3-content">
                        <SubNav id={id} current={7} tournament={tournament} />
                    </div>}
                    <RankingsSection {...this.props} partial={true} params={params} ageGroups={ageGroups} />
                    {tournament && tournament.IsESPN && <ESPN tournament={tournament} />}
                </div>
            </section>
        </Layout>
    }
}

export default Rankings;



// WEBPACK FOOTER //
// ./src/components/tournaments/rankings.js